import CodeExamples from './code-examples.view';

export default CodeExamples;
